// Register.js
import React, { useState } from 'react';
import api from '../../helper/util/api';
import { useNavigate } from 'react-router-dom';

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [message, setMessage] = useState(null);

  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const res = await api.post('/auth/register', { name, email, phone, password, role })
      setMessage('Registered successfully. Please login.');
      alert('Registered successfully. Please login.');
      setTimeout(() => {
      }, 2000);
    } catch (err) { console.error(err); alert('Error while user registration'); }
  }

  return (
      <div className="app-container">
        <div className="header">
          <h2>Register New User</h2>
        </div>
        <div className="panel">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-row two-col-row">
              <input value={name} onChange={e => setName(e.target.value)} placeholder="Name" required />
            </div>
            <div className="form-row two-col-row">
              <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" required />
            </div>
            <div className="form-row two-col-row">
              <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="Phone" />
            </div>
            <div className="form-row two-col-row">
              <input value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" required />
            </div>
            <div className="form-row two-col-row">
              <select className="input" name="role" value={role} onChange={e => setRole(e.target.value)}>
                <option value="">-- Select Role --</option>
                <option value="executive">Executive</option>
                <option value="manager">Manager</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <div className="form-row two-col-row">
              <button type="submit">Register</button>
              {message && <p>{message}</p>}
            </div>
          </form>
        </div>
      </div>
  );
}
